module.exports = __webpack_public_path__ + "img/名校直通车蓝色.5f000f2b.png";